import cn from "classnames";
import { useTranslate } from "@/hooks";
import { parsingButtonInMessage } from "@/helpers";
import { ButtonType } from "@/helpers/parsingChatMessageButtons";
import { IButtonBlockProps } from "./ButtonBlock.props";
import styles from "./ButtonBlock.module.scss";

const ButtonBlock = ({
	buttonsInPhrase,
	setButtonsInPhrase,
	setSelectButtonType,
	setButtonChangeFlg,
	setInputButtonName,
	setInputButtonData,
	setAnchorForButtonForm,
	isDisabled,
}: IButtonBlockProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	// вставить знак переноса строки
	const insertOrRemoveLineBreak = ({ blockIdx, buttonIdx }: { blockIdx: number; buttonIdx: number }): void => {
		setButtonsInPhrase((prev) => {
			if (prev[blockIdx][buttonIdx].includes("\n")) {
				prev[blockIdx][buttonIdx] = prev[blockIdx][buttonIdx].replace("\n", "");
			} else {
				prev[blockIdx][buttonIdx] += "\n";
			}
			return [...prev];
		});
	};

	// обработчик открытия формы редактирования кнопки
	const buttonEditFormOpenHandler = (
		e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
		buttonType: ButtonType,
		buttonCode: string,
		buttonName: string,
		buttonData: string
	): void => {
		// если есть доступ
		if (!isDisabled) {
			setSelectButtonType(buttonType); // устанавливаем тип кнопки
			setButtonChangeFlg({ isChange: true, originalTemplate: buttonCode }); // ставим флаг изменения кнопки
			// заполняем поля
			setInputButtonName(buttonName); // название кнопки
			setInputButtonData(buttonData); // данные кнопки
			setAnchorForButtonForm(e.currentTarget); // открываем форму
		}
	};

	return (
		<>
			{buttonsInPhrase.map((buttonBlock, blockIdx) => (
				<div className={styles.buttonBlock} key={blockIdx}>
					{buttonBlock.map((buttonCode, buttonIdx) => {
						const { buttonType, buttonName, buttonData } = parsingButtonInMessage(buttonCode); // парсинг кнопки
						return (
							<div className={styles.buttonBlockInner} key={buttonCode}>
								{/* кнопка */}
								<button
									className={styles.button}
									type="button"
									onClick={(e) => buttonEditFormOpenHandler(e, buttonType, buttonCode, buttonName, buttonData)}
									title={buttonName}
								>
									{buttonName}
								</button>
								{/* перенос строки */}
								{!isDisabled && (
									<button
										type="button"
										className={cn(styles.button, styles.buttonSeparator, {
											[styles.buttonSeparatorShow]: buttonCode.includes("\n"),
										})}
										onClick={() => insertOrRemoveLineBreak({ blockIdx, buttonIdx })}
										title={translate(buttonCode.includes("\n") ? "button_removeLineBreak" : "button_insertLineBreak")}
									>
										&crarr;
									</button>
								)}
							</div>
						);
					})}
				</div>
			))}
		</>
	);
};

export default ButtonBlock;
